import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Typography } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Catalogus from "../../components/catalogus/Catalogus";
import {
	fetchProductGroupsFarmer,
	fetchProductsByGroupFarmer,
	getAllSupplierInfo,
	getAssortiment,
	obtainProductInfo,
} from "../../services/assortiment/actions";
import {
	changeFarmer,
	changeHoofdgroep,
	changeProducts,
	changeSearchTerm,
	changeSubgroep,
	changeSubproducts,
	changeUsedSearchTerm,
	setShowCatalogus,
	setShowHoofdgroep,
	setShowSubgroep,
} from "../../services/currentInformation/actions";
import HorizontalMenuScroll from "../home/HorizontalMenuScroll";
import "./Assortiment.scss";

const usePropChangeEffect = (func, deps) => {
	const didMount = useRef(false);

	useEffect(() => {
		if (didMount.current) func();
		else didMount.current = true;
		// eslint-disable-next-line
	}, deps);
};

function PublicAssortiment(props) {
	const [open, setOpen] = useState(false);

	const handleClose = () => setOpen(false);
	const [assortiment, setAssortiment] = useState([]);
	const [hoofdgroepen, setHoofdgroepen] = useState([]);
	const [currentHoofdgroep, setCurrentHoofdgroep] = useState(
		props.currentHoofdgroup
	);
	const [subDict, setSubDict] = useState(props.currentSubproducts);
	const [currentSubgroep, setCurrentSubgroep] = useState(props.currentSubgroup);
	const [products, setProducts] = useState([]); //OR Keep this from state
	const [allSuppliersInfo, setAllSupplierInfo] = useState([]);
	const [currentSupplier, setCurrentSupplier] = useState(props.currentFarmer);
	const [searchQuery, setSearchQuery] = useState(props.searchTerm);
	const [productsFoundByQuery, setProductsFoundByQuery] = useState(
		props.usedSearchTerm
	);
	const [mainGroupProducts, setMainGroupProducts] = useState([]);
	const [showCompleteCatalogue, setShowCompleteCatalogue] = useState(true);

	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setOpen(false);
	};

	useEffect(() => {
		console.log("RAN");
		props.fetchProductGroupsFarmer(props.loginSuccesful, props.identifyInfo);
	}, []);

	const handleOpen = () => {
		setProductsFoundByQuery(false);
		props.changeUsedSearchTerm(false);
		setSearchQuery("");
		props.changeSearchTerm("");
	};

	const getHoofdgroepen = () => {
		const res = props.productGroups.map((row) => {
			return row.main_group_name;
		});
		const ids = props.productGroups.map((row) => {
			return row.main_group_id;
		});
		console.dir(props.currentHoofdgroup);

		if (
			(props.currentHoofdgroup.name == "") |
			(props.currentHoofdgroup.name == undefined)
		) {
			props.changeHoofdgroep({ name: res[0], id: ids[0] });
			props.changeSubgroep("");
		}
	};

	const getSubGroepen = () => {
		const temp = assortiment.filter(
			(row) => row.main_group_name == props.currentHoofdgroup.name
		);
		console.dir(props.currentHoofdgroup);
		console.dir(temp);
		//console.dir(temp[0].sub_groups);
		if (temp.length > 0) {
			props.changeSubproducts(temp[0].sub_groups);
			//Check if necessary
			if (props.currentSubgroup === "") {
				props.changeSubgroep(temp[0].sub_groups[0].sub_group_name);
			}
		}
	};

	const getProducten = () => {
		const temp = props.currentSubproducts.filter(
			(row) => row.sub_group_name == props.currentSubgroup
		);
		console.dir(temp);
		if (temp.length > 0 && (!props.usedSearchTerm || props.SearchTerm == "")) {
			setProducts(temp[0].products);
		}
	};

	useEffect(() => {
		getAllSupplierInfo(
			props.loginSuccesful,
			props.identifyInfo,
			setAllSupplierInfo
		);
	}, []);

	useEffect(() => {
		getAssortiment(
			props.identifyInfo,
			props.currentFarmer,
			props.loginSuccesful,
			setAssortiment
		);
	}, [props.identifyInfo, props.currentFarmer]);

	useEffect(() => {
		console.dir(assortiment);
		if (assortiment.length > 0) {
			getHoofdgroepen();
		}
	}, [assortiment]);

	useEffect(() => {
		//HIERR
		console.log(props.currentHoofdgroup.id);
		setShowCompleteCatalogue(true);
		fetchProductsByGroupFarmer(
			props.loginSuccesful,
			props.identifyInfo,
			props.currentHoofdgroup.id,
			setMainGroupProducts
		);

		if (assortiment.length > 0) {
			getSubGroepen();
		}
	}, [assortiment, props.currentHoofdgroup.id]);

	useEffect(() => {
		console.dir(mainGroupProducts);
	}, [mainGroupProducts]);

	useEffect(() => {
		if (!props.usedSearchTerm | (props.searchTerm == "")) {
			props.changeSearchTerm("");
			props.changeUsedSearchTerm(false);
			console.dir(assortiment);
			if (
				props.productGroups?.length > 0 &&
				props.currentSubproducts?.length > 0
			) {
				getProducten();
			}
		}
	}, [props.productGroups, props.currentSubgroup, props.usedSearchTerm]);

	useEffect(() => {
		if (props.searchTerm?.length >= 2) {
			setShowCompleteCatalogue(false);
			obtainProductInfo(
				props.searchTerm,
				props.identifyInfo,
				props.loginSuccesful,
				props.currentLocation,
				props.changeUsedSearchTerm,
				setProducts
			);
			// props.setShowCatalogus(true);
			// props.setShowHoofdgroep(false);
			// props.setShowSubgroep(false);
		} else {
			setShowCompleteCatalogue(true);
		}
	}, [props.searchTerm]);

	const assortimentColumnsTable = [
		{ name: "Naam", dataName: "name" },
		{ name: "Prijs", dataName: "salesprice" },
	];

	const drawerWidth = 240;

	const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
		({ theme, open }) => ({
			flexGrow: 1,
			padding: theme.spacing(3),
			transition: theme.transitions.create("margin", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			marginRight: -drawerWidth,
			...(open && {
				transition: theme.transitions.create("margin", {
					easing: theme.transitions.easing.easeOut,
					duration: theme.transitions.duration.enteringScreen,
				}),
				marginRight: 0,
			}),
		})
	);

	const AppBar = styled(MuiAppBar, {
		shouldForwardProp: (prop) => prop !== "open",
	})(({ theme, open }) => ({
		transition: theme.transitions.create(["margin", "width"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		...(open && {
			width: `calc(100% - ${drawerWidth}px)`,
			transition: theme.transitions.create(["margin", "width"], {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.enteringScreen,
			}),
			marginRight: drawerWidth,
		}),
	}));

	const DrawerHeader = styled("div")(({ theme }) => ({
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar,
		justifyContent: "flex-start",
	}));

	const HoofdgroupGrid = () => {
		const theme = useTheme();
		const [open, setOpen] = React.useState(false);

		const handleDrawerOpen = () => {
			//setShowCompleteCatalogue(true);
			setOpen(true);
		};

		const handleDrawerClose = () => {
			setOpen(false);
		};

		return (
			<Box sx={{ display: "flex" }}>
				<CssBaseline />
				<Toolbar>
					<div style={{ width: window.screen.width * 0.8 }}>
						<HorizontalMenuScroll
							data={props.productGroups}
							title="Hoofdgroep"
							type="Main Group"
						/>
					</div>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						edge="end"
						onClick={handleDrawerOpen}
						sx={{ ...(open && { display: "none" }) }}
					>
						<FilterAltIcon fontSize="large" />
					</IconButton>
				</Toolbar>

				<Drawer variant="persistent" anchor="bottom" open={open}>
					<DrawerHeader>
						<IconButton onClick={handleDrawerClose}>
							{theme.direction === "rtl" ? (
								<ChevronLeftIcon />
							) : (
								<ChevronRightIcon />
							)}
						</IconButton>
					</DrawerHeader>
					<Divider />
					{props.currentSubproducts.length > 0 && (
						<List>
							{props.currentSubproducts.map((row) => (
								<div
									onClick={() => {
										props.changeSubgroep(row.sub_group_name);
										props.setShowSubgroep(false);
										props.setShowCatalogus(true);
										setShowCompleteCatalogue(false);
									}}
								>
									<ListItem key={row.sub_group_name} disablePadding>
										<ListItemButton>
											<ListItemIcon>
												<img // TODO: images moeten allemaal dezelfde afmetingen hebben
													src={row.image}
													style={{
														height: 40,
														width: 40,
														marginLeft: 10,
													}}
												/>
											</ListItemIcon>
											<ListItemText primary={row.sub_group_name} />
										</ListItemButton>
									</ListItem>
								</div>
							))}
						</List>
					)}
					<Divider />
				</Drawer>
			</Box>
			// <HorizontalMenuScroll
			//   data={assortiment}
			//   title="Hoofdgroep"
			//   type="Main Group"
			// />
			//   <Grid
			//     container
			//     justifyContent="center"
			//     alignItems="flex-start"
			//     spacing={3}
			//   >
			//     {assortiment.map((row) => (
			//       <Grid item xs={6}>
			//         <Paper>
			//           <div
			//             onClick={() => {
			//               props.changeHoofdgroep(row.main_group_name);
			//               props.setShowHoofdgroep(false);
			//               props.setShowSubgroep(true);
			//             }}
			//           >
			//             {row.image && (
			//               <div style={{ textAlign: "center" }}>
			//                 <div style={{ position: "relative", width: "100%" }}>
			//                   <img // TODO: images moeten allemaal dezelfde afmetingen hebben
			//                     src={row.image}
			//                     style={{
			//                       height: 100,
			//                       width: 100,
			//                     }}
			//                   />
			//                   <div className="cardContentGroups">
			//                     {row.main_group_name}
			//                   </div>
			//                 </div>
			//               </div>
			//             )}
			//           </div>
			//         </Paper>
			//       </Grid>
			//     ))}
			//   </Grid>
		);
	};

	const SubgroupGrid = () => {
		return (
			<HorizontalMenuScroll
				data={props.currentSubproducts}
				title="Subgroep"
				type="Sub Group"
			/>
			// <Grid
			//   container
			//   justifyContent="center"
			//   alignItems="flex-start"
			//   spacing={3}
			// >
			//   {props.currentSubproducts.map((row) => (
			//     <Grid item xs={6}>
			//       <Paper>
			//         <div
			//           onClick={() => {
			//             props.changeSubgroep(row.sub_group_name);
			//             props.setShowSubgroep(false);
			//             props.setShowCatalogus(true);
			//           }}
			//         >
			//           {row.image && (
			//             <div style={{ textAlign: "center" }}>
			//               <div style={{ position: "relative", width: "100%" }}>
			//                 <img // TODO: images moeten allemaal dezelfde afmetingen hebben
			//                   src={row.image}
			//                   style={{
			//                     height: 100,
			//                     width: 100,
			//                   }}
			//                 />
			//                 <div className="cardContentGroups">
			//                   {row.sub_group_name}
			//                 </div>
			//               </div>
			//             </div>
			//           )}
			//         </div>
			//       </Paper>
			//     </Grid>
			//   ))}
			// </Grid>
		);
	};

	const MainGroupProducts = (props) => {
		return props.subgroups.map((sub_group) => (
			<div>
				<h2 className="subName" style={{ textAlign: "left", marginTop: 5 }}>
					{sub_group.name}
				</h2>
				<Catalogus
					data={sub_group.products}
					columnsMapping={assortimentColumnsTable}
					publicAssortiment={true}
				/>
			</div>
		));
	};

	return (
		<>
			<>
				{props.productGroups?.length > 0 && props.showHoofdgroep && (
					<HoofdgroupGrid />
				)}
				<br />
				<Divider />
				<br />

				{showCompleteCatalogue ? (
					<MainGroupProducts subgroups={mainGroupProducts} />
				) : (
					props.showCatalogus &&
					products?.length > 0 && (
						<div>
							{!props.usedSearchTerm ? (
								<div>
									<h2 className="subName" style={{ textAlign: "left" }}>
										{props.currentSubgroup}
									</h2>
								</div>
							) : (
								<Typography style={{ fontWeight: "bold" }}>
									Resultaten voor "{props.searchTerm}"
								</Typography>
							)}
							<Catalogus
								data={products}
								columnsMapping={assortimentColumnsTable}
								publicAssortiment={true}
							/>
						</div>
					)
				)}

				{/* {props.showCatalogus && products?.length > 0 && (
          <div>
            {!props.usedSearchTerm ? (
              <div>
                <h2 className="subName" style={{ textAlign: "left" }}>
                  {props.currentSubgroup}
                </h2>
              </div>
            ) : (
              <Typography style={{ fontWeight: "bold" }}>
                Resultaten voor "{props.searchTerm}"
              </Typography>
            )}
            <Catalogus
              data={products}
              columnsMapping={assortimentColumnsTable}
              publicAssortiment={true}
            />
          </div>
        )} */}
			</>
		</>
	);
}

function mapStateToProps(state) {
	return {
		identifyInfo: state.identify.identifyInfo,
		loginSuccesful: state.login.data.loginSuccesful,
		farmers: state.login.data.farmers,
		currentLocation: state.currentInformation.current_location,
		currentFarmer: state.currentInformation.current_farmer,
		currentHoofdgroup: state.currentInformation.current_hoofdgroup,
		currentSubgroup: state.currentInformation.current_subgroup,
		currentSubproducts: state.currentInformation.current_subproducts,
		usedSearchTerm: state.currentInformation.used_search_term,
		currentProducts: state.currentInformation.current_products,
		searchTerm: state.currentInformation.search_term,
		showCatalogus: state.currentInformation.show_catalogus,
		showHoofdgroep: state.currentInformation.show_hoofdgroep,
		showSubgroep: state.currentInformation.show_subgroep,
		productGroups: state.assortiment.product_groups_farmer,
	};
}

export default connect(mapStateToProps, {
	changeFarmer,
	changeHoofdgroep,
	changeSubgroep,
	changeSubproducts,
	changeUsedSearchTerm,
	changeProducts,
	changeSearchTerm,
	setShowCatalogus,
	setShowHoofdgroep,
	setShowSubgroep,
	fetchProductGroupsFarmer,
})(PublicAssortiment);
